import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import { useLocale } from '../../i18n/locale-context.js';
export function EmblemMark({ height = 40, className }) {
    const { t } = useLocale();
    const [status, setStatus] = React.useState('pending');
    if (status === 'error')
        return null;
    return (_jsx("img", { src: "/emblem-nepal.svg", alt: t('govIdentity.emblemAlt'), height: height, className: className, style: {
            height,
            // `auto` + `contain` so the artwork keeps its own aspect ratio whatever file is
            // dropped in: the production emblem comes from the ministry and may not match the
            // stand-in's proportions exactly.
            width: 'auto',
            objectFit: 'contain',
            display: status === 'loaded' ? 'inline-block' : 'none',
        }, onLoad: () => setStatus('loaded'), onError: () => setStatus('error') }));
}
//# sourceMappingURL=EmblemMark.js.map